import { render } from "./SpecimenStatusBall.vue?vue&type=template&id=854e08d6&scoped=true"
import script from "./SpecimenStatusBall.vue?vue&type=script&lang=js"
export * from "./SpecimenStatusBall.vue?vue&type=script&lang=js"

import "./SpecimenStatusBall.vue?vue&type=style&index=0&id=854e08d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854e08d6"]])

export default __exports__